import "./Navbar.css";
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
//import { useAuth } from "../../../context/AuthContext";
import { useAuth } from "./AuthContext";

const Navbar = () => {
  const { user, role, userPermissions, logout } = useAuth();
  const navigate = useNavigate();

  const normalizedRole = role?.toLocaleLowerCase("tr-TR");
  const isOwner = normalizedRole === "oluşturucu";

  const hb =
    userPermissions?.["hazir-beton"] ||
    userPermissions?.["hazir_beton"] ||
    userPermissions?.["hazirBeton"] ||
    userPermissions?.["hazirbeton"] ||
    {};

  // ⭐ DOĞRU ÇALIŞAN YETKİ MANTIĞI (turn19file2’den birebir alındı)
  const canGiris = isOwner || hb.giris || hb.duzeltme;
  const canDuzelt = isOwner || hb.duzeltme;
  const canRapor = isOwner || hb.duzeltme || hb.giris || hb.rapor;
  const canHakedis = isOwner || hb.izleyen === true;

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <nav className="navbar">
      <div className="navbar-left" onClick={() => navigate("/hazir-beton/carsaf-sevkiyat")}>
        <img src="/logo.png" alt="logo" className="navbar-logo" />
        <span className="navbar-title">Hazır Beton Operasyonları</span>
      </div>

      {user && role && (
        <div className="navbar-links">

          {canGiris && (
            <NavLink className="navbar-link" to="/hazir-beton/carsaf-sevkiyat">
              Çarşaf (Sevkiyat)
            </NavLink>
          )}

          {canGiris && (
            <NavLink className="navbar-link" to="/hazir-beton/carsaf-pompa">
              Pompa Hakediş
            </NavLink>
          )}

          {canGiris && (
            <NavLink className="navbar-link" to="/hazir-beton/zone-yukle">
              Zone Yükle
            </NavLink>
          )}

          {canRapor && (
            <NavLink className="navbar-link" to="/hazir-beton/hazirbeton-rapor">
              Rapor
            </NavLink>
          )}

          {canGiris && (
            <NavLink className="navbar-link" to="/hazir-beton/puantaj">
              Puantaj
            </NavLink>
          )}


          {canDuzelt && (
            <NavLink className="navbar-link" to="/hazir-beton/sevkiyat-duzelt">
              Sevkiyat Düzelt / Soft Sil
            </NavLink>
          )}

          <NavLink className="navbar-link" to="/secilen-proje">
            🔁 Proje Seç
          </NavLink>

          <button className="logout-button" onClick={handleLogout}>
            Çıkış
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
